<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates20">
<p class="centerImage1"><img alt="images" id="plate20" src="images/plate20.jpg"/></p>
<p class="caption">Sight-seeing outside Sydney. Left to right: John Lenagen, George Farries, Harold Leonard, RWF, Robin Norwood and Tony Brook.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates20.vue?14a8fdd9